import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FloatingButtons from '@/pages/home/components/FloatingButtons';
import Accordion from '@/components/base/Accordion';
import ProgressiveImage from '@/components/base/ProgressiveImage';

const features = [
  { icon: 'ri-emotion-happy-line', title: 'Uzman Ekip', desc: 'Ev eşyası ve ofis mobilyası konusunda deneyimli ambalaj ve taşıma ekibimiz.' },
  { icon: 'ri-archive-2-line', title: 'Profesyonel Paketleme', desc: 'Kırılabilir eşyalar için özel ambalaj malzemeleri kullanıyoruz. Hasarsız taşıma garantisi.' },
  { icon: 'ri-shield-check-line', title: 'Sigorta Güvencesi', desc: 'Tüm ev ve ofis taşımalarında kapsamlı eşya sigortası sunuyoruz.' },
  { icon: 'ri-door-open-line', title: 'Kapıdan Kapıya', desc: 'Eski adresinizden alır, yeni adresinize kurulum dahil teslim ederiz.' },
];

const faqs = [
  { q: 'Montaj ve demontaj hizmeti veriyor musunuz?', a: 'Evet, mobilya ve beyaz eşyaların söküm ve kurulum işlemlerini de gerçekleştiriyoruz.' },
  { q: 'Eşyalarım ne kadar sürede teslim edilir?', a: 'Türkiye - Almanya arası ev ve ofis taşımada ortalama 5–10 iş günü içinde teslimat yapılır.' },
  { q: 'Değerli eşyalar için özel paketleme yapıyor musunuz?', a: 'Evet, sanat eserleri, akvaryumlar ve hassas elektronikler için özel ambalaj yapıyoruz.' },
  { q: 'Fiyat nasıl belirleniyor?', a: 'Taşınacak eşya miktarına (m³) ve adrese göre hesaplanır. Ücretsiz keşif yapıp fiyat veriyoruz.' },
];

export default function EvOfisPage() {
  return (
    <main className="font-sans">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-brand-navy overflow-hidden">
        <div className="absolute inset-0">
          <ProgressiveImage
            src="/media/search-image-8b1b030331.jpg"
            alt="Ev & Ofis Taşıma"
            className="object-cover object-top opacity-20"
            priority
          />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-2 mb-6 flex-wrap">
            <Link to="/" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Anasayfa</Link>
            <span className="text-white/30 text-sm">/</span>
            <Link to="/hizmetlerimiz" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Hizmetlerimiz</Link>
            <span className="text-white/30 text-sm">/</span>
            <span className="text-brand-orange text-sm font-medium">Ev & Ofis Taşıma</span>
          </div>
          <span className="inline-flex items-center gap-2 bg-brand-orange/20 border border-brand-orange/30 text-brand-orange text-xs font-semibold px-3 py-1 rounded-full mb-5 uppercase tracking-widest">
            <i className="ri-home-4-line"></i> Hizmet 03
          </span>
          <h1 className="text-white font-heading font-bold text-4xl md:text-5xl mb-6 leading-tight">
            Ev & Ofis Taşıma<br />
            <span className="text-brand-orange">Türkiye&apos;den Avrupa&apos;nın Her Ülkesine</span>
          </h1>
          <p className="text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">
            Türkiye&apos;nin 81 ilinden Avrupa&apos;nın 27 ülkesine evinizi veya ofisinizi anahtar teslim taşıyoruz. Paketlemeden kuruluma, kapıdan kapıya her adım bizden.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a
              href="https://wa.me/905322376576?text=Merhaba%2C%20ev%20ta%C5%9F%C4%B1ma%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></span>
              Fiyat Teklifi Al
            </a>
            <Link
              to="/iletisim"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white/20 text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-send-line text-base"></i></span>
              Form ile Ulaşın
            </Link>
          </div>
        </div>
      </section>

      {/* Visual + Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative rounded-2xl overflow-hidden h-[380px] md:h-[500px]">
              <ProgressiveImage
                src="/media/search-image-5126b586a5.jpg"
                alt="Ev & Ofis Taşıma"
                className="object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 rounded-xl p-4 flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-lg flex-shrink-0">
                    <i className="ri-home-heart-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-brand-navy font-heading font-bold text-sm">Anahtar Teslim Taşıma</div>
                    <div className="text-gray-400 text-xs mt-0.5">Paketlemeden kuruluma her şey dahil</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Neden Biz?</p>
              <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-8">Güvenli & Hasarsız Taşıma</h2>
              <div className="flex flex-col gap-5">
                {features.map((f, i) => (
                  <div key={i} className="flex items-start gap-4 p-4 rounded-xl border border-gray-100 hover:border-brand-orange/20 transition-all duration-300">
                    <div className="w-11 h-11 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl flex-shrink-0">
                      <i className={`${f.icon} text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-brand-navy font-heading font-bold text-sm mb-1">{f.title}</h3>
                      <p className="text-gray-400 text-sm leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Taşıma Süreci</p>
              <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-10">Adım Adım Taşınma</h2>
              <div className="flex flex-col gap-5">
                {[
                  { step: '01', title: 'Keşif', desc: 'Eşyalarınızı yerinde inceleyip ücretsiz fiyat veriyoruz.', icon: 'ri-search-2-line' },
                  { step: '02', title: 'Paketleme', desc: 'Tüm eşyaları özel malzemelerle profesyonelce paketliyoruz.', icon: 'ri-archive-2-line' },
                  { step: '03', title: 'Yükleme & Taşıma', desc: "Araçlara güvenli yükleme yapılır, Avrupa'ya doğrudan sefer.", icon: 'ri-truck-line' },
                  { step: '04', title: 'Teslimat & Kurulum', desc: 'Yeni adresinizde kurulum ve yerleştirme dahil teslim.', icon: 'ri-home-4-line' },
                ].map((s, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="flex flex-col items-center flex-shrink-0">
                      <div className="w-12 h-12 flex items-center justify-center bg-brand-navy text-white rounded-full">
                        <i className={`${s.icon} text-lg`}></i>
                      </div>
                      {i < 3 && <div className="w-0.5 h-6 bg-gray-200 mt-2"></div>}
                    </div>
                    <div className="pt-2">
                      <span className="text-brand-orange font-bold text-xs uppercase tracking-widest">{s.step}</span>
                      <h4 className="text-brand-navy font-heading font-bold text-base mt-0.5 mb-1">{s.title}</h4>
                      <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-[380px] md:h-[480px]">
              <ProgressiveImage
                src="/media/search-image-e5fd6fd294.jpg"
                alt="Ev Taşıma Süreci"
                className="object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent pointer-events-none"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-brand-navy/90 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-brand-orange animate-pulse flex-shrink-0"></div>
                    <p className="text-white text-sm font-medium">Türkiye&apos;den Avrupa&apos;ya — 5 adımda stressiz taşınma</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="mb-12 text-center">
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">SSS</p>
            <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl">Sık Sorulan Sorular</h2>
            <p className="text-gray-400 text-sm mt-3">Merak ettiklerinizi tıklayarak öğrenin</p>
          </div>
          <Accordion items={faqs} />
        </div>
      </section>

      {/* Other Services */}
      <section className="py-16 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <p className="text-gray-400 text-sm mb-6 font-medium">Diğer Hizmetlerimiz</p>
          <div className="flex flex-wrap gap-3">
            {[
              { label: 'Parsiyel Taşımacılık', href: '/hizmetlerimiz/parsiyel', icon: 'ri-box-3-line' },
              { label: 'Komple Araç', href: '/hizmetlerimiz/komple-arac', icon: 'ri-truck-line' },
              { label: 'Hızlı Kargo', href: '/hizmetlerimiz/hizli-kargo', icon: 'ri-flashlight-line' },
            ].map((s) => (
              <Link
                key={s.href}
                to={s.href}
                className="inline-flex items-center gap-2 border border-gray-200 text-brand-navy hover:border-brand-orange hover:text-brand-orange px-4 py-2.5 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className={`${s.icon} text-base`}></i></span>
                {s.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </main>
  );
}
